import api from '../api'

import { loadEntity } from 'lib/actionHelpers'

export default async function loadPublicOrganizations(){
  return loadEntity.call(this, {
    reload: false,
    entityKey: 'publicOrganizationApikeys',
    request: () =>
      api.getPublicOrganizations().then(({ organizations }) => {
        this.takeAction('organization.addOrganizationsToAppState', organizations)
        return new Set(organizations.map(o => o.apikey))
      })
    ,
  })
}
